<template>
	<div id="wrapper"
	@mousemove="updateMouseMove"
	:class="{
		'hovertarget': hovertarget,
		'stage_LOADED': stage==='LOADED',
		'stage_ENTERED': stage==='ENTERED'
		}"
	>
		<div id="container" ref="container">
			<!-- SIMULATION BASED ON https://codepen.io/sciecode/pen/WgaRwN -->
			<!-- https://discourse.threejs.org/t/help-making-a-specific-animation/21171 -->
		</div>

		<div
		v-show="stage==='ENTERED'"
		class="cursor"
		:class="{
			'hovertarget': hoverContext
			}"
		ref="cursor"
		>
			<span v-if="hoverContext" class="">{{hoverContext.display_id}}</span>
		</div>

		<!-- <div class="box" v-show="selectedtarget">
			{{selectedtarget}}
		</div> -->

		<!-- <div class="fixed left-0 top-1/2 text-white text-3xl z-50"> -->
			<!-- polarAngle:{{polarAngle}}<br>
			azimuthalAngle:{{azimuthalAngle}}<br>
			distance:{{distance}}<br> -->
			<!-- calls: {{calls}} -->
		<!-- </div> -->

		<transition name="fadeinfo" mode="out-in">
			<div class="box" v-if="selectContext" :key="selectContext.display_id">
				<div class="caption">
					<div class="text-1 serif">
						<span class="object-id">{{selectContext.display_id}}</span>
						{{selectContext.text1}}
					</div>
					<div class="text-2 serif">
						{{selectContext.text2}}
					</div>
				</div>
			</div>
		</transition>

	</div>
</template>

<script>
import _ from 'lodash'
// import Ammo from './Ammo'
import {captions} from '@/common/content.js'

import * as THREE from 'three';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import gsap from "gsap";
import { GUI } from 'three/examples/jsm/libs/dat.gui.module.js';
import { OrbitControls, MapControls } from 'three/examples/jsm/controls/OrbitControls.js';
// import { DragControls } from 'three/examples/jsm/controls/DragControls.js';
// import { VertexNormalsHelper } from 'three/examples/jsm/helpers/VertexNormalsHelper.js';
// import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js';
// import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
// import { Reflector } from 'three/examples/jsm/objects/Reflector.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import { USDZExporter } from 'three/examples/jsm/exporters/USDZExporter.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { BufferGeometryUtils } from 'three/examples/jsm/utils/BufferGeometryUtils.js';

export default {
	name: 'Jewellery',
	data () {
		return {
			loaded: false,
			hovertarget: null,
			selectedtarget: null,
			hasSelected: false,
			hoverContext: null,
			selectContext: null,
			enableInteraction: true,
			enableSceneContent: true,
			polarAngle:0,
			azimuthalAngle:0,
			distance:0,
			calls: 0
		}
	},
	mounted () {

		this.stateUpdateStageASLoading()

		this.constructUserInterface()

		this.constructThreeDimensionalScene ()

		// this.updateHoverTarget(2)
	},
	computed: {
		stage () {
      return this.$store.state.stage
    }
	},
	components: {
    // Ammo,
  },
	watch: {
		hovertarget (newVal, oldVal) {
			if (newVal) {
				console.log(newVal)
				this.updateCursor(true)
				this.updateHoverTarget(newVal)
			} else {
				this.updateCursor(false)
				this.updateHoverTarget()
			}
		},
		'$route' (newVal, oldVal) {
			if (newVal.name != 'Home') {
				this.disableScene ()
			} else {
				this.enableScene ()
			}
		}
	},
	methods: {

		forceUpdate () {
			this.$forceUpdate();
		},

		disableScene () {
			this.enableSceneContent = false
			// this.enableInteraction = false
		},

		enableScene () {
			this.enableSceneContent = true
			// this.enableInteraction = true
		},

		updateMouseDown () {
			if (this.hoverContext) {
				this.selectContext = _.clone(this.hoverContext)
			} else {
				this.selectContext = null
			}
		},

		updateMouseMove (ev) {
			// console.log(ev.clientX, ev.clientY)
			gsap.to('.cursor', {
				x: ev.clientX,
				y: ev.clientY,
				duration: 0,
				ease: 'power0.linear'
			})
		},

		updateHoverTarget (boo) {
			if (boo) {
				if (captions && captions[boo]) {
					this.hoverContext = captions[boo]
				}
			} else {
				this.hoverContext = null
			}
		},

		updateCursor (boo) {
			if (boo) {
				gsap.killTweensOf('.cursor')
				gsap.to('.cursor', {
					scale: 1.5,
					duration: 1,
					opacity: 1,
					ease: 'elastic.out(1,0.3)'
				})
			} else {
				gsap.killTweensOf('.cursor')
				gsap.to('.cursor', {
					scale: 0,
					opacity: 0.5,
					duration: .5,
					ease: 'elastic.out(1,0.3)'
				})
			}
		},

		stateUpdateStageASLoading() {
			if (this.stage!=='ENTERED') {
				this.$store.commit('setStage', { stage: 'LOADING' })
			}
		},

		stateUpdateStageFromLoadingToLoaded() {
			if (this.stage!=='ENTERED') {
				this.$store.commit('setStage', { stage: 'LOADED' })
			}
		},

		stateUpdateUSDZ(url) {
			if (!url) return;
			this.$store.commit('setUSDZ', { usdz: url })
		},
		// exportScene () {
    //   if (!threejs_scene) return
    //   exportGLTF(threejs_scene)
    // },
		// shuffleBlocks () {
		// 	if (this.shuffle) {
		// 		this.shuffle()
		// 	}
		// },
		// takeSnapshot () {
		// 	if (this.snap) {
		// 		return this.snap()
		// 	}
		// },

		constructUserInterface () {
			this.updateCursor(false)
		},

		constructThreeDimensionalScene () {

			function isTouchDevice() {
			  return (('ontouchstart' in window) ||
			     (navigator.maxTouchPoints > 0) ||
			     (navigator.msMaxTouchPoints > 0));
			}

			//
			let self=this

			const scale = 0.5
			const WIDTH = window.innerWidth;
			const HEIGHT = window.innerHeight;
			const raycaster = new THREE.Raycaster();
			const mouse = new THREE.Vector2();
			const defaultLightsReferencePoint = new THREE.Vector3(0,0,0);
			// let directionalLight;
			// linear color space
			const API = {
				lightProbeIntensity: 0.5,
				directionalLightIntensity: 0.5,
				directionalLightIntensity2: 0.2,
				spotLightIntensity: 0.1,
				pointLightIntensity: 0.5,
				envMapIntensity: 0.5,
				directionalLightPositionX: 5,
				directionalLightPositionY: 100,
				directionalLightPositionZ: -50,
				directionalLight2PositionX: 100,
				directionalLight2PositionY: 100,
				directionalLight2PositionZ: -100,
			};
			const container = self.$refs.container
			const urlParams = new URLSearchParams(window.location.search);
			let param_controls = urlParams.get('controls');
			let param_gui = urlParams.get('gui');
					param_controls = true
					param_gui = false

			let camera, scene, renderer;
			let controls;
			let model;
			let gui, stats;
			let lightProbe;
			let rayTargets=[];
			let displayTargets=[];
			let floor, floorShadow;
			let pointLight, directionalLight, directionalLight2, spotLight;
			let pmremGenerator;
			let textureEquirec, textureCube;
			let jewelleryMaterial, planeMaterial;
			let tempHoverTarget=-1;
			let geometries=[];

			let lastCameraPostiion = new THREE.Vector3()
			// let canCancelHoverHighlight=true;

			init();
			initStats()
			// render();
			// animate();

			function init() {

				initCameraScene()
				initLights()
				// initGUI()
				initRenderer()
				initControls()
				initEventListeners()
				initAssets()

			}

			function stateLoadingComplete () {

				//
				self.loaded = true

				setTimeout(()=>{
					self.stateUpdateStageFromLoadingToLoaded()
				}, 5000)

				controls.update();
				render();
				effectsIntroduction()
			}

			function stateIntroductionComplete () {

				render();

			}

			function effectsIntroduction () {

				// gsap.to(renderer, {
				// 	toneMappingExposure: 1,
				// 	duration: 5,
				// 	delay: 1
				// })

				// scene.fog.material.needsUpdate = true
				//
				// gsap.to(scene.fog, {
				// 	density: 0.01, //0.005
				// 	duration: 5,
				// 	delay: 1
				// })

				// controls.autoRotate = true
				// controls.autoRotateSpeed = 0.2
				// controls.maxPolarAngle = 40 * Math.PI / 180;
				// controls.minPolarAngle = 40 * Math.PI / 180;
				// controls.minDistance = 300;
				// controls.maxDistance = 300;
				// controls.target.set(0, -20, 0);
				// controls.update();

				let speed = 0.7

				// animate();

				gsap.killTweensOf(controls)
				gsap.fromTo(controls, {
					minDistance: 400,
					maxDistance: 400,
					maxAzimuthAngle: 0,
					minAzimuthAngle: 0,
					maxPolarAngle: 0 * Math.PI / 180,
					minPolarAngle: 0 * Math.PI / 180,
				}, {
					minDistance: 300,
					maxDistance: 300,
					maxAzimuthAngle: 0,
					minAzimuthAngle: 0,
					maxPolarAngle: 40 * Math.PI / 180,
					minPolarAngle: 40 * Math.PI / 180,
					duration: 10 * speed,
					delay: 0,
					ease: "power3.inOut",
					onStart: () => {
						// render()
					},
					onUpdate: () => {
						controls.update()
						render()
					},
					onComplete: () => {
						stateIntroductionComplete()
						controls.maxAzimuthAngle=Infinity
						controls.minAzimuthAngle=Infinity
						animate();
						// floor.visible=false
					}
				})

				gsap.to(jewelleryMaterial, {
					envMapIntensity: API.envMapIntensity,
					opacity: 1,
					duration: 7 * speed,
					ease: "power4.inOut",
					delay: 3 * speed,
					onComplete: () => {
						for (let i = 0; i < displayTargets.length; i++) {
							displayTargets[i].material = jewelleryMaterial.clone()
						}
					}
				})

				gsap.to(planeMaterial, {
					envMapIntensity: API.envMapIntensity,
					duration: 10 * speed,
					delay: 0 * speed
				})

				if (directionalLight) {
					gsap.to(directionalLight, {
						intensity: API.directionalLightIntensity,
						duration: 10 * speed,
						ease: "power4.inOut",
						delay: 3 * speed
					})
				}

				if (directionalLight2) {
					gsap.to(directionalLight2, {
						intensity: API.directionalLightIntensity2,
						duration: 5 * speed,
						ease: "power4.inOut",
						delay: 3 * speed
					})
				}

				if (pointLight) {
					gsap.to(pointLight, {
						intensity: API.pointLightIntensity,
						duration: 10 * speed,
						ease: "power4.inOut",
						delay: 3 * speed
					})
				}

				if (directionalLight) {
					gsap.fromTo(directionalLight.position, {
						x: API.directionalLightPositionX,
						y: API.directionalLightPositionY*0.75,
						z: API.directionalLightPositionZ,
					},{
						x: API.directionalLightPositionX,
						y: API.directionalLightPositionY,
						z: API.directionalLightPositionZ,
						duration: 5 * speed,
						ease: "power4.inOut",
						delay: 3 * speed
					})
				}

				if (directionalLight2) {
					gsap.fromTo(directionalLight2.position, {
						x: API.directionalLight2PositionX,
						y: API.directionalLight2PositionY*0.75,
						z: API.directionalLight2PositionZ,
					},{
						x: API.directionalLight2PositionX,
						y: API.directionalLight2PositionY,
						z: API.directionalLight2PositionZ,
						duration: 5 * speed,
						ease: "power4.inOut",
						delay: 3 * speed
					})
				}
			}

			function disableSceneTransition () {
				let speed = 0.1
				// gsap.to(controls, {
				// 	minDistance: 400,
				// 	maxDistance: 400,
				// 	maxPolarAngle: 0 * Math.PI / 180,
				// 	minPolarAngle: 0 * Math.PI / 180,
				// 	maxAzimuthAngle: 0,
				// 	minAzimuthAngle: 0,
				// 	duration: 10 * speed,
				// 	delay: 0,
				// 	ease: "power3.inOut",
				// 	onStart: () => {
				// 	},
				// 	onUpdate: () => {
				// 		render()
				// 	},
				// 	onComplete: () => {
				// 	}
				// })

				let alpha = {
					val: 1,
					to: 0
				}
				gsap.to(alpha, {
					val: alpha.to,
					duration: 5 * speed,
					delay: 0,
					ease: "power3.inOut",
					onStart: () => {
						self.enableInteraction=false
					},
					onUpdate: () => {
						// for ( let i = 0; i < rayTargets.length; i ++ ) {
						// 	let r = rayTargets[i]
						// 	if (r&&r.material) {
						// 		r.material.opacity=alpha.val+0.05
						// 	}
						// }
						// console.log('disable',alpha.val)
						// // // floor.material.opacity=alpha.val
						// floorShadow.material.opacity=alpha.val*API.envMapIntensity
						renderer.toneMappingExposure = alpha.val+0;
						render()
					},
					onComplete: () => {
						// self.enableInteraction=false
					}
				})
			}

			function enableSceneTransition () {
				let speed = 0.1
				// gsap.to(controls, {
				// 	minDistance: 300,
				// 	maxDistance: 300,
				// 	maxPolarAngle: 40 * Math.PI / 180,
				// 	minPolarAngle: 40 * Math.PI / 180,
				// 	maxAzimuthAngle: Math.PI * 2 * 2 * 2 * 2,
				// 	minAzimuthAngle: - Math.PI * 2 * 2 * 2 * 2,
				// 	duration: 10 * speed,
				// 	delay: 0,
				// 	ease: "power3.inOut",
				// 	onStart: () => {
				// 	},
				// 	onUpdate: () => {
				// 		render()
				// 	},
				// 	onComplete: () => {
				// 	}
				// })
				let alpha = {
					val: 0,
					to: 1
				}
				gsap.to(alpha, {
					val: alpha.to,
					duration: 1 * speed,
					delay: 0,
					ease: "power3.inOut",
					onStart: () => {
					},
					onUpdate: () => {
						// for ( let i = 0; i < rayTargets.length; i ++ ) {
						// 	let r = rayTargets[i]
						// 	if (r&&r.material) {
						// 		if (r.material.opacity<alpha.val) {
						// 			r.material.opacity=alpha.val
						// 		}
						// 	}
						// }
						// console.log('enable',alpha.val)
						// // floor.material.opacity=alpha.val*API.envMapIntensity
						// floorShadow.material.opacity=alpha.val*API.envMapIntensity
						renderer.toneMappingExposure = alpha.val;
						render()
					},
					onComplete: () => {
						self.enableInteraction=true
					}
				})
			}

			function initStats () {

				stats = new Stats();
				stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
				container.appendChild( stats.dom );
				stats.dom.style.left='unset'
				stats.dom.style.top='unset'
				stats.dom.style.right=0
				stats.dom.style.bottom=0
				stats.dom.style.opacity=0.0

			}

			// function initGUI () {
			//
			// 	if (param_gui && param_gui=='true' || param_gui==true) {
			//
			// 		gui = new GUI();
			//
			// 		gui.width = 300;
			// 		gui.domElement.style.userSelect = 'none';
			//
			// 		const fl = gui.addFolder( 'Intensity' );
			//
			// 		// fl.add( API, 'lightProbeIntensity', 0, 1, 0.02 )
			// 		// 	.name( 'light probe' )
			// 		// 	.onChange( function () {
			// 		//
			// 		// 		lightProbe.intensity = API.lightProbeIntensity; render();
			// 		//
			// 		// 	} );
			//
			// 		fl.add( API, 'directionalLightIntensity', 0, 3, 0.02 )
			// 			.name( 'directional light' )
			// 			.onChange( function () {
			//
			// 				directionalLight.intensity = API.directionalLightIntensity; render();
			//
			// 			} );
			//
			// 		fl.add( API, 'directionalLightIntensity2', 0, 3, 0.02 )
			// 			.name( 'directional light 2' )
			// 			.onChange( function () {
			//
			// 				directionalLight2.intensity = API.directionalLightIntensity2; render();
			//
			// 			} );
			//
			// 		fl.add( API, 'spotLightIntensity', 0, 3, 0.02 )
			// 			.name( 'spotLight' )
			// 			.onChange( function () {
			//
			// 				spotLight.intensity = API.spotLightIntensity; render();
			//
			// 			} );
			//
			// 		fl.open();
			//
			// 	}
			//
			// }


			function initAssets () {

				// stateLoadingComplete()

				// return;

				new THREE.TextureLoader()
						// .load('/textures/matcaps/PushingPoints_Matcaps/hotspot.png', function(texture) {
						// .load('/textures/matcaps/PushingPoints_Matcaps/Warmsteel.png', function(texture) {
						.load('/textures/gradient6.png', function(texture) {

						initEnvironment(texture)
						render();

						new THREE.TextureLoader()
								.load('/textures/floor1-50.png', function(floorTexture) {

									initFloor(floorTexture)

									// const model = '/models/initial layout2 nofloor notag 93pc.gltf'
									// const model = '/models/Final Layout 95pc.glb'
									// const model = 'https://design-district-map.s3.eu-west-2.amazonaws.com/glb/DD-all-baked-tex-11-compressed-5.glb'
									// const model = '/models/NewFinalLayout-95.glb'
									// const model = isTouchDevice()?'https://hato-public.s3.amazonaws.com/assets/the-collection/NewFinalLayout-97.glb':'https://hato-public.s3.amazonaws.com/assets/the-collection/NewFinalLayout-95.glb'
									// const model = '/models/NewFinalLayout-95-v3.glb'

									// const model = '/models/NewFinalLayout-95-v3-draco.gltf'
									// const raycasterModel = '/models/NewFinalLayout-95-raycaster-model-draco.gltf'
									const raycasterModel = 'https://hato-public.s3.amazonaws.com/assets/the-collection/NewFinalLayout-95-raycaster-model-draco.gltf'
									const model = 'https://hato-public.s3.amazonaws.com/assets/the-collection/NewFinalLayout-95-v3-draco.gltf'
									const loader = new GLTFLoader()
									const dracoLoader = new DRACOLoader();
									dracoLoader.setDecoderPath( '/draco/' );
									loader.setDRACOLoader( dracoLoader );

									// const model = '/models/gltfpack.glb'
									// const loader = new GLTFLoader()

									loader.load(raycasterModel,
										function(gltf) {
											initRaycasterModel(gltf)
											stateLoadingComplete()
										},
										function ( xhr ) {
											console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded 2' );
										},
										function ( error ) {
											//
										})

									loader.load(model,
										function(gltf) {
											initJewellery(gltf)
											stateLoadingComplete()
											// scene.scale.set(0.05, 0.05, 0.05)
											// exportGLTF(scene)
											// exportUSDZ(scene)
											// exportUSDZ(scene)
											// exportGLTF(scene)
										},
										function ( xhr ) {
											console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded 1' );
										},
										function ( error ) {
											//
										});

								})

					});

			}

			function exportGLTF (input) {

				const gltfExporter = new GLTFExporter();

				const options = {
					trs: false,
					onlyVisible: true,
					truncateDrawRange: true,
					binary: false,
					maxTextureSize: 4096 || Infinity // To prevent NaN value
				};
				gltfExporter.parse( input, function ( result ) {

					if ( result instanceof ArrayBuffer ) {

						saveArrayBuffer( result, 'scene.glb' );

					} else {

						const output = JSON.stringify( result, null, 2 );
						console.log( output );
						saveString( output, 'scene.gltf' );

					}

				}, options );

			}

			function saveString( text, filename ) {

				save( new Blob( [ text ], { type: 'text/plain' } ), filename );

			}


			function saveArrayBuffer( buffer, filename ) {

				save( new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename );

			}

			function save( blob, filename ) {

				const link = document.getElementById( 'gltf-link' );
				link.href = URL.createObjectURL( blob );
				link.download = filename;
				link.click();

				// URL.revokeObjectURL( url ); breaks Firefox...

			}

			async function exportUSDZ (input) {

				// USDZ
				const exporter = new USDZExporter();
				// const exporter = new GLTFExporter();

				const arraybuffer = await exporter.parse( input );
				const blob = new Blob( [ arraybuffer ], { type: 'application/octet-stream' } );

				const link = document.getElementById( 'usdz-link' );
				// link.href = URL.createObjectURL( blob );
				self.usdz_href = URL.createObjectURL( blob );

				link.href = self.usdz_href

				const href = URL.createObjectURL( blob );

				if (href) {
					self.stateUpdateUSDZ(href)
				}

			}

			function initCameraScene () {

				camera = new THREE.PerspectiveCamera(45, WIDTH / HEIGHT, 1, 1000);
				camera.position.set(0, 75, 50);
				scene = new THREE.Scene();

			}

			function initEnvironment (texture) {

				const envMap = pmremGenerator.fromEquirectangular(texture).texture;

				// envMap.encoding = THREE.sRGBEncoding

				// scene.background = new THREE.Color('#6e6666');
				// scene.background.encoding = THREE.sRGBEncoding
				// scene.fog = new THREE.FogExp2( 0x4e4444, 0.003 );
				scene.environment = envMap;

				texture.dispose();
				pmremGenerator.dispose();

			}

			function initJewellery (gltf) {
				// let target;
				gltf.scene.traverse(function(child) {

					// if (child.name.indexOf('B1Glass')>=0) {
					// 	child.material.opacity=0.3
					// 	child.material.roughness=0.1
					// 	child.material.metalness=0.9
					// }

					// console.log(child)

					if (child.children.length>10) {
						console.log(child.name)
						// rayTargets = child.children
					}

					if (child.isMesh) {

						if (child.geometry) {
							// geometries.push(child.geometry)
						}

						if (child.name) {
							let name = _.clone(child.name)
							 let num = _.split(name, '_', 1)
							 if (num&&+num[0]>=0||name=='mesh_0') {

									let groupID = +num[0]
									// child.
									let UID = _.snakeCase(name)

									child.userData.uid = UID
									child.userData.groupid = groupID

									child.castShadow = true
									child.receiveShadow = true

									if (!jewelleryMaterial) {
										jewelleryMaterial = child.material.clone()
										jewelleryMaterial.color = new THREE.Color( 1, 1, 1 );
										jewelleryMaterial.roughness=0.7
										jewelleryMaterial.metalness=0.5
										jewelleryMaterial.transparent=true
										jewelleryMaterial.envMapIntensity=0.1
										jewelleryMaterial.opacity=0.1
										// jewelleryMaterial.side = THREE.doubleSide
									}

									child.material = jewelleryMaterial

									// console.log(child)

									// child.geometry = new THREE.Geometry().fromBufferGeometry( child.geometry );

							    // child.geometry.mergeVertices();

							    child.geometry.computeVertexNormals();

							    // convert back to BufferGeometry prior to rendering
							    // child.geometry = new THREE.BufferGeometry().fromGeometry( child.geometry );

									// rayTargets.push(child)
									displayTargets.push(child)
							 }
						}

					}

				});

				gltf.scene.scale.set(scale, scale, scale)

				// const geometry = BufferGeometryUtils.mergeBufferGeometries( geometries );
				// 			geometry.computeBoundingSphere();
				//
				// const mesh = new THREE.Mesh( geometry, new THREE.MeshLambertMaterial( { color: new THREE.Color( 1, 0, 0 ), side: THREE.DoubleSide } ) );
				// 			scene.add( mesh );
				// gltf.scene.position.x = -110
				// gltf.scene.position.z = -50

				scene.add(gltf.scene);
			}

			function initRaycasterModel (gltf) {
				// let target;
				gltf.scene.traverse(function(child) {

					// if (child.name.indexOf('B1Glass')>=0) {
					// 	child.material.opacity=0.3
					// 	child.material.roughness=0.1
					// 	child.material.metalness=0.9
					// }

					// console.log('initRaycasterModel',child)

					if (child.isMesh) {

						if (child.geometry) {
							// geometries.push(child.geometry)
						}

						if (child.name) {
							let name = _.clone(child.name)
							 let num = _.split(name, '_', 1)
							 if (num&&+num[0]>=0||+name>=0) {
									let groupID = +num[0]
									// child.
									let UID = _.snakeCase(name)
									child.userData.uid = UID
									child.userData.groupid = groupID
									child.visible=false
									rayTargets.push(child)
							 }
						}

					}

				});

				gltf.scene.scale.set(scale*14.25, scale*14.25, scale*14.25)
				scene.add(gltf.scene);
			}

			function initLights () {


				directionalLight = new THREE.DirectionalLight( 0xffffff, 0 );
				directionalLight.position.x = 5
				directionalLight.position.y = 100
				directionalLight.position.z = -50
				directionalLight.position.x = 0
				directionalLight.position.y = 0
				directionalLight.position.z = 0
				let light = directionalLight;

				//Set up shadow properties for the light
				// directionalLight.shadow.mapSize.width = 512*8; // default
				// directionalLight.shadow.mapSize.height = 512*8; // default
				// directionalLight.shadow.camera.near = 0.5; // default
				// directionalLight.shadow.camera.far = 500*8; // default
				scene.add( directionalLight );

				directionalLight2 = new THREE.DirectionalLight( 0xeeeeff, 0 );
				directionalLight2.position.x = 100
				directionalLight2.position.y = 100
				directionalLight2.position.z = -100
				directionalLight2.position.x = 0
				directionalLight2.position.y = 0
				directionalLight2.position.z = 0
				scene.add( directionalLight2 );

				// spotLight = new THREE.SpotLight( 0xffffee, 0 );
				// spotLight.position.x = 5
				// spotLight.position.y = 10
				// spotLight.position.z = 5
				// scene.add( spotLight );



				//Create a PointLight and turn on shadows for the light

				pointLight = new THREE.PointLight( 0xffffff, 0, 150, 3 );
				pointLight.position.set( -0, 150, 0 );
				scene.add( pointLight );



				//Set up shadow properties for the light
				// light.shadow.mapSize.width = 512; // default
				// light.shadow.mapSize.height = 512; // default
				// light.shadow.camera.near = 0.5; // default
				// light.shadow.camera.far = 500; // default

				// const d = isTouchDevice()?128:128*2
				// light.shadow.camera.left = - d;
				// light.shadow.camera.right = d;
				// light.shadow.camera.top = d;
				// light.shadow.camera.bottom = - d;
				// light.castShadow = true; // default false
				// light.shadow.mapSize.width = isTouchDevice()?d*2:d*16; // default
				// light.shadow.mapSize.height = isTouchDevice()?d*2:d*16; // default
				// light.shadow.radius = 1;

				const d = 128*4
				light.shadow.camera.left = - d;
				light.shadow.camera.right = d;
				light.shadow.camera.top = d;
				light.shadow.camera.bottom = - d;
				light.castShadow = true; // default false
				light.shadow.mapSize.width = isTouchDevice()?d*4:d*8; // default
				light.shadow.mapSize.height = isTouchDevice()?d*4:d*8; // default
				light.shadow.radius = 2;

				// probe
				// lightProbe = new THREE.LightProbe();
				// scene.add( lightProbe );

			}

			function adjustControls () {

				const polarAngle = controls.getPolarAngle();
				const azimuthalAngle = controls.getAzimuthalAngle();
				const distance = controls.object.position.distanceTo( controls.target );

				// self.polarAngle=polarAngle
				// self.azimuthalAngle= _.round(azimuthalAngle,2)
				// self.distance=distance

				// let factor = Math.PI/2-Math.abs(Math.PI/2 - Math.abs(azimuthalAngle))
				let xFactor = Math.PI/2-Math.abs(Math.PI/2 - Math.abs(azimuthalAngle))
				let zFactor = Math.abs(Math.PI/2 - Math.abs(azimuthalAngle))
				let xLimit = 100*1.5
				let zLimit = 20*1.5
				let newX = azimuthalAngle > 0 ? xFactor * 100 : -xFactor * 100
				let newZ = Math.abs(azimuthalAngle) < Math.PI/2 ? zFactor * 20 : -zFactor * 20
				// let newX = factor * 100;
				let targetX = Math.min(Math.max(-xLimit, newX),xLimit)
				let targetZ = Math.min(Math.max(-zLimit, newZ),zLimit)
				// console.log(factor)
				// controls.target.set(targetX, -20, targetZ);
				controls.target.set(targetX, 0, targetZ);

				// self.polarAngle=`${_.round(newX,1)} ${_.round(newZ,1)}`
				// self.azimuthalAngle= _.round(azimuthalAngle,2)
				// self.polarAngle=`${_.round(zFactor,1)}`
				// self.azimuthalAngle=`${_.round(newZ,1)}`
				// self.distance=_.round(azimuthalAngle,1)

			}

			function limitMapControls () {
			}

			function initControls () {

				if (!isTouchDevice()) {

					// desktop
					// controls = new OrbitControls(camera, renderer.domElement);
					// controls.enableDamping = isTouchDevice()?false:true;
					// controls.dampingFactor = 0.1;
					// controls.screenSpacePanning = false;
					// controls.autoRotate = true;
					// controls.autoRotateSpeed = 0.2;
					// controls.maxPolarAngle = 40 * Math.PI / 180;
					// controls.minPolarAngle = 40 * Math.PI / 180;
					// controls.minDistance = 300;
					// controls.maxDistance = 300;
					// controls.target.set(0, -20, 0);
					// controls.addEventListener('change', () => {
					// 	adjustControls()
					// });

					controls = new MapControls(camera, renderer.domElement);
					controls.enableDamping = true;
					controls.dampingFactor = 0.2;
					controls.screenSpacePanning = false;
					controls.autoRotate = false;
					controls.autoRotateSpeed = 0;
					controls.maxPolarAngle = 40 * Math.PI / 180;
					controls.minPolarAngle = 40 * Math.PI / 180;
					// controls.minAzimuthAngle = - Math.PI * 2; // radians
					// controls.maxAzimuthAngle = Math.PI * 2; // radians
					controls.minDistance = 300;
					controls.maxDistance = 300;
					controls.target.set(0, -20, 0);

					let limit = {
						x: [-100,100],
						y: [-150,150],
						z: [-50,50],
					}
					var minPan = new THREE.Vector3( limit.x[0], limit.y[0], limit.z[0] );
					var maxPan = new THREE.Vector3( limit.x[1], limit.y[1], limit.z[1] );
					var _v = new THREE.Vector3();

					controls.addEventListener('change', () => {
						_v.copy(controls.target);
						controls.target.clamp(minPan, maxPan);
						_v.sub(controls.target);
						camera.position.sub(_v);

						if (!self.selectContext) {
							lastCameraPostiion.copy(camera.position)
							// console.log(lastCameraPostiion)
						}
					});

				} else {

					// mobile
					controls = new MapControls(camera, renderer.domElement);
					controls.enableDamping = true;
					controls.dampingFactor = 0.2;
					controls.screenSpacePanning = false;
					controls.autoRotate = false;
					controls.autoRotateSpeed = 0;
					controls.maxPolarAngle = 40 * Math.PI / 180;
					controls.minPolarAngle = 40 * Math.PI / 180;
					controls.minDistance = 300;
					controls.maxDistance = 300;
					controls.target.set(0, -20, 0);

					let limit = {
						x: [-200,200],
						y: [-150,150],
						z: [-150,150],
					}
					var minPan = new THREE.Vector3( limit.x[0], limit.y[0], limit.z[0] );
					var maxPan = new THREE.Vector3( limit.x[1], limit.y[1], limit.z[1] );
					var _v = new THREE.Vector3();

					controls.addEventListener('change', () => {
						_v.copy(controls.target);
						controls.target.clamp(minPan, maxPan);
						_v.sub(controls.target);
						camera.position.sub(_v);

						if (!self.selectContext) {
							lastCameraPostiion.copy(camera.position)
							// console.log(lastCameraPostiion)
						}
					});

				}
				controls.update();

			}

			function initRenderer () {
				renderer = new THREE.WebGLRenderer({
					antialias: true,
					alpha: true
				});

				let pixelRatio = isTouchDevice() ? 1.5 : (window.devicePixelRatio || 2)
				// let pixelRatio = window.devicePixelRatio || 2
				renderer.setPixelRatio(pixelRatio);
				renderer.setSize(window.innerWidth, window.innerHeight);

				renderer.toneMapping = THREE.ACESFilmicToneMapping;
				renderer.toneMappingExposure = 1;
				renderer.outputEncoding = THREE.sRGBEncoding;
				renderer.gammaOutput = true;
				renderer.gammaFactor = 2.2;
				renderer.shadowMap.enabled = true;
				renderer.shadowMap.renderReverseSided = false;
				// renderer.shadowMap.type = THREE.PCFSoftShadowMap; // default THREE.PCFShadowMap

				container.appendChild(renderer.domElement);

				pmremGenerator = new THREE.PMREMGenerator(renderer);
				pmremGenerator.compileEquirectangularShader();
			}

			function initFloor (floorTexture) {
				const size = 1024
				const planeGeometry = new THREE.BoxBufferGeometry( size, size, size );
				// const planeGeometry = new THREE.CircleGeometry( 512, 32 );
				// planeGeometry.rotateX( - Math.PI / 2 );

				floorTexture.wrapS = floorTexture.wrapT = THREE.RepeatWrapping;
				floorTexture.encoding = THREE.sRGBEncoding;
				floorTexture.repeat.set(40, 40);

				const floorNormalMap = new THREE.TextureLoader().load( '/textures/floornormal.png' );
				floorNormalMap.wrapS = floorNormalMap.wrapT = THREE.RepeatWrapping;
				floorNormalMap.encoding = THREE.sRGBEncoding;
				floorNormalMap.repeat.set(40, 40);

				const mattNormal = new THREE.TextureLoader().load( '/textures/matcaps/9926-normal.jpg' );
				mattNormal.wrapS = mattNormal.wrapT = THREE.RepeatWrapping;
				mattNormal.encoding = THREE.sRGBEncoding;
				mattNormal.repeat.set(1, 1);
				const mattNormalScale = new THREE.Vector2(1,1)

				planeMaterial = new THREE.MeshStandardMaterial( {
					color: 0x776666,
					envMapIntensity: 0,
					map: floorTexture,
					normalMap: floorNormalMap,
					normalScale: new THREE.Vector2(0.1,0.1),
					roughness: 0.7,
					metalness: 0.8,
					side: THREE.BackSide
				} )
				// planeMaterial.transparent = true;
				planeMaterial.opacity = 1;

				const plane = new THREE.Mesh( planeGeometry, planeMaterial );
				plane.receiveShadow = true;
				plane.position.y = size/2 + 0.5;
				// plane.translateY(512/2)
				scene.add( plane );

				// const geometry = new THREE.PlaneGeometry( 2000, 2000 );
				// geometry.rotateX( - Math.PI / 2 );

				// const material = new THREE.ShadowMaterial();
				// material.transparent = true;
				// material.opacity = 0.5;
				//
				// const plane2 = new THREE.Mesh( planeGeometry, material );
				// plane2.position.y = 0.5;
				// plane2.receiveShadow = true;
				// scene.add( plane2 );

				// floorShadow = plane2

				floor = plane
				floor.name = 'floor'

				floorTexture.dispose()
			}

			function updateLights (point = defaultLightsReferencePoint) {

				let limit = {
					x: [-150,150],
					y: [0, 100],
					z: [-150,150],
				}
				// console.log(point.x, point.z)

				if (pointLight) {
					gsap.to(pointLight.position, {
						x:_.clamp(point.x, limit.x[0], limit.x[1]),
						y:_.clamp(point.y+20, limit.y[0], limit.y[1]),
						z:_.clamp(point.z, limit.z[0], limit.z[1]),
						duration: 2,
						ease: 'power0.linear'
					})
				}

				if (directionalLight) {
					gsap.to(directionalLight.position, {
						x:_.clamp(point.x-5, limit.x[0], limit.x[1]),
						y:_.clamp(point.y+100, limit.y[0], limit.y[1]),
						z:_.clamp(point.z-50, limit.z[0], limit.z[1]),
						duration: 60,
						ease: 'power0.linear'
					})
				}
				if (directionalLight2) {
					gsap.to(directionalLight2.position, {
						x:_.clamp(point.x+100, limit.x[0], limit.x[1]),
						y:_.clamp(point.y+100, limit.y[0], limit.y[1]),
						z:_.clamp(point.z-100, limit.z[0], limit.z[1]),
						duration: 60,
						ease: 'power0.linear'
					})
				}
			}

			let updateHoverTargets = _.throttle((intersects) => {

				// console.log('updateHoverTargets')

				let tarRef=intersects[0].object.userData.groupid

				// canCancelHoverHighlight=false

				if (tempHoverTarget==tarRef) {
					return
				} else {
					tempHoverTarget=tarRef
					// debounceCancelHoverHighlight()
				}

				self.hovertarget = tarRef

				// console.log('updateHoverTargets execute')

				// let alpha = {
				// 	val: 1,
				// 	to: 0
				// }
				// gsap.to(alpha, {
				// 	val: alpha.to,
				// 	duration: 1,
				// 	delay: 0,
				// 	ease: "power3.out",
				// 	onStart: () => {
				// 		// self.enableInteraction=false
				// 	},
				// 	onUpdate: () => {
				// 		for ( let i = 0; i < rayTargets.length; i ++ ) {
				// 			let r = rayTargets[i]
				// 			if (r.userData.groupid!=intersects[0].object.userData.groupid) {
				// 				if (r&&r.material) {
				// 					let newVal = Math.min(alpha.val+0.2, r.material.opacity)
				// 					r.material.opacity=newVal
				// 					r.castShadow = false
				// 				}
				// 			} else {
				// 				if (r&&r.material) {
				// 					let newVal = Math.max(1-alpha.val, r.material.opacity)
				// 					r.material.opacity=newVal
				// 					r.castShadow = true
				// 				}
				// 			}
				// 		}
				// 		// console.log('disable',alpha.val)
				// 		// // // floor.material.opacity=alpha.val
				// 		// floorShadow.material.opacity=alpha.val*API.envMapIntensity
				// 		// renderer.toneMappingExposure = alpha.val+0;
				// 		// render()
				// 	},
				// 	onComplete: () => {
				// 		// self.enableInteraction=false
				// 	}
				// })

				// for ( let i = 0; i < rayTargets.length; i ++ ) {
				// 	let r = rayTargets[i]
				// 	if (r.userData.groupid!=intersects[0].object.userData.groupid) {
				// 		if (r&&r.material) {
				// 			let newVal = Math.min(0+0.2, r.material.opacity)
				// 			r.material.opacity=newVal
				// 			r.castShadow = false
				// 		}
				// 	} else {
				// 		if (r&&r.material) {
				// 			let newVal = Math.max(1-0, r.material.opacity)
				// 			r.material.opacity=newVal
				// 			r.castShadow = true
				// 		}
				// 	}
				// }

				controls.autoRotate=false

				// floor.material.emissive = new THREE.Color( 0.2, 0.2, 0.2 );
				// floorShadow.material.opacity = 0.2

			}, 0, {
				leading: true,
				trailing: true
			})

			let highlightHoverTarget = _.debounce(() => {

				if (!self.hovertarget) {
					self.selectContext=null
					self.hovertarget=null
				}

				// debugger
				let id = self.selectContext && self.selectContext.id;
				let display_id = self.selectContext && self.selectContext.display_id;
				if (!id) return;


				let avgTarget = {
					x: 0,
					y: 0,
					z: 0,
					dist: 250
				}
				// let newTargetPosition = new THREE.Vector3(controls.target.x,controls.target.y,controls.target.z)
				for ( let i = 0; i < displayTargets.length; i ++ ) {
					let r = displayTargets[i]
					if (r.userData.groupid!=id) {
						if (r&&r.material) {
							let newVal = Math.min(0+0.2, r.material.opacity)
							r.material.opacity=newVal
							r.castShadow = false
						}
					} else {
						if (r&&r.material) {
							let newVal = Math.max(1-0, r.material.opacity)
							r.material.opacity=newVal
							r.castShadow = true
							avgTarget.x=r.position.x
							avgTarget.y=r.position.y
							avgTarget.z=r.position.z
						}
					}
				}

				console.log('display_id', display_id, avgTarget.x, avgTarget.y)

				let scale = -1
				let newTarget = {
					'1': {dist:250, x:10, y:0, z:10},
					'2': {dist:250, x:69, y:0, z:-37},
					'3': {dist:250, x:-45, y:0, z:-40},
					'4': {dist:280, x:0, y:0, z:15},
					'5': {dist:250, x:31, y:0, z:58},
					'6': {dist:250, x:30, y:0, z:50},
					'7': {dist:250, x:-88, y:0, z:-20},
					'8': {dist:250, x:41, y:0, z:32},
					'9': {dist:250, x:-37, y:0, z:80},
					'10': {dist:250, x:160, y:0, z:0},
					'11': {dist:250, x:-12, y:0, z:-48},
				}

				if (newTarget[display_id]) {
					avgTarget.x=newTarget[display_id].x * scale
					avgTarget.z=newTarget[display_id].z * scale
					avgTarget.dist=newTarget[display_id].dist
				}

				console.log('avgTarget', avgTarget.x, avgTarget.z)
				// this.minAzimuthAngle = []
				// this.maxAzimuthAngle = []

				if (window && window.innerWidth<768) {
					// don't animate scene
				} else {
					gsap.to(scene.position, {
						x: avgTarget.x,
						y: 0,
						z: avgTarget.z,
						duration: 3,
						delay: 0,
						ease: "power1.inOut"
					})
				}

				gsap.to(controls, {
					minDistance: avgTarget.dist || 250,
					maxDistance: avgTarget.dist || 250,
					maxPolarAngle: 30 * Math.PI / 180,
					minPolarAngle: 30 * Math.PI / 180,
					// minAzimuthAngle: 0,
					// maxAzimuthAngle: 0,
					duration: 3,
					delay: 0,
					ease: "power3.out",
					// onStart: () => {
					// 	// render()
					// },
					// onUpdate: () => {
					// 	// console.log('zooming in...', controls.target)
					// },
					// onComplete: () => {
					// 	stateIntroductionComplete()
					// 	animate();
					// 	// floor.visible=false
					// }
				})
				// console.log('disable',alpha.val)
				// // // floor.material.opacity=alpha.val
				// floorShadow.material.opacity=alpha.val*API.envMapIntensity

			}, 0, {
				leading: false,
				trailing: true
			})

			// let debounceCancelHoverHighlight = _.debounce((object) => {
			// 	// console.log('debounceCancelHoverHighlight')
			// 	canCancelHoverHighlight = true;
			// }, 200, {
			// 	leading: false
			// })

			// let updateAllMaterials = _.throttle((object) => {
			// 	// console.log('updateAllMaterials')
			//
			// }, 500, {
			// 	// leading: true
			// })

			let resetHoverTarget = _.debounce((object) => {

				tempHoverTarget=-1
				self.hovertarget=null

			}, 0, {
				leading: false,
				trailing: true
			})

			let resetHighlights = _.debounce((object) => {

				tempHoverTarget=-1
				self.hovertarget=null

				for ( let i = 0; i < displayTargets.length; i ++ ) {
					let r = displayTargets[i]
					if (r&&r.material) {
						let newVal = Math.max(1, r.material.opacity)
						r.material.opacity=newVal
						r.castShadow = true
					}
				}

				gsap.to(scene.position, {
					x: 0,
					y: 0,
					z: 0,
					duration: 2,
					delay: 0,
					ease: "power3.out"
				})

				gsap.killTweensOf(controls)
				gsap.to(controls, {
					minDistance: 300,
					maxDistance: 300,
					maxPolarAngle: 40 * Math.PI / 180,
					minPolarAngle: 40 * Math.PI / 180,
					// minAzimuthAngle: - 2 * Math.PI,
					// maxAzimuthAngle: 2 * Math.PI,
					duration: 2,
					delay: 0,
					ease: "power3.out",
					// onStart: () => {
					// 	// render()
					// },
					// onUpdate: () => {
					// 	controls.update()
					// 	render()
					// },
					// onComplete: () => {
					// 	controls.minAzimuthAngle = - Infinity; // radians
					// 	controls.maxAzimuthAngle = Infinity; // radians
					// 	// stateIntroductionComplete()
					// 	// animate();
					// 	// floor.visible=false
					// }
				})
				// floorShadow.material.opacity = 0.5
				controls.autoRotate=true

			}, 0, {
				leading: false,
				trailing: true
			})

			let handleHighlight = _.throttle((intersects) => {

				// alert('handleHighlight')
				// console.log('handleHighlight')
				// canCancelHoverHighlight=false
				if (intersects[0].object.name=='floor') {
					// console.log('floor...')
					// deselect
					resetHoverTarget ()
					if (self.selectContext && self.selectContext.id) {
						return
					}
					resetHighlights ()
				} else {
					// console.log('found!')
					// found
					updateHoverTargets (intersects)
				}
			}, 50, {
				leading: true
			})

			function ray() {

				// if (isTouchDevice())return;

				if (!self.enableInteraction) return;
				// return
				if (!rayTargets || rayTargets.length<1) return;
				// update the picking ray with the camera and mouse position
				raycaster.setFromCamera( mouse, camera );

				// calculate objects intersecting the picking ray
				const intersects = raycaster.intersectObjects( [...rayTargets, floor] );
				// const intersects = raycaster.intersectObjects( [floor] );

				// for ( let i = 0; i < intersects.length; i ++ ) {
				//
				// 	// intersects[ i ].object.material.color.set( 0xff0000 );
				// 	// console.log(intersects[ i ].object.name)
				// 	// if (intersects[ i ].object.name=='floor') {
				// 		// console.log(intersects[ i ].point.x,intersects[ i ].point.z)
				// 	// } else {
				// 		//
				// 	// }
				// }

				// if (!isTouchDevice()) {
					if (!intersects[0]||!intersects[0].point) {
						updateLights()
					} else {
						updateLights(intersects[0].point)
						// console.log('point', Math.round(intersects[0].point.x), Math.round(intersects[0].point.z))
					}
				// }
				// pointLight.position.x=intersects[0].point.x
				// pointLight.position.y=intersects[0].point.y+20
				// pointLight.position.z=intersects[0].point.z

				if (!intersects.length) return;

				handleHighlight(intersects)

			}

			function initEventListeners () {

				window.addEventListener( 'resize', onWindowResize);
				renderer.domElement.addEventListener( 'mousemove', onMouseMove, false );
				renderer.domElement.addEventListener( 'touchstart', onTouchStart, false );
				// window.addEventListener( 'mousedown', onMouseDown, false );

				// renderer.domElement.addEventListener('mousemove', ()=>{
				//    console.log('mousemove');
				// });
				renderer.domElement.addEventListener('pointerdown', onPointerDown, false);
				renderer.domElement.addEventListener('pointerup', onPointerUp, false);

			}

			function onMouseMove( event ) {

				if (!self.enableSceneContent) return;
				// calculate mouse position in normalized device coordinates
				// (-1 to +1) for both components
				if (event.changedTouches && event.changedTouches[0] && event.changedTouches[0].clientX && event.changedTouches[0].clientY) {
					event = event.changedTouches[0]
				}


				mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
				mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
				// alert(`onMouseMove ${mouse.x} ${mouse.y}`);

			}

			function onMouseDown( event ) {

				if (!self.enableSceneContent) return;
				self.updateMouseDown()
				onMouseMove( event )

			}

			function onPointerDown( event ) {

				if (!self.enableSceneContent) return;
				// alert('pointerdown');
				self.updateMouseDown()
				highlightHoverTarget()
			}

			function onPointerUp( event ) {
				console.log('pointerup');
			}

			function onTouchStart(event) {

				if (!self.enableSceneContent) return;
				// alert('onTouchStart')
				onMouseMove(event)
				ray()
				onPointerDown(event)
			}


			function onWindowResize() {

				camera.aspect = window.innerWidth / window.innerHeight;
				camera.updateProjectionMatrix();

				renderer.setSize(window.innerWidth, window.innerHeight);

				render();

			}

			//

			function render() {

				controls.update();
				self.calls=renderer.info.render.calls
				renderer.render(scene, camera);

			}

			function animate() {

				if (self.enableSceneContent) {
					if (stats) {
						stats.begin();
					}
				}

				// // if enable scene flag is on
				if (isTouchDevice()) {

						if (self.enableSceneContent) {
							ray()
							render()
						}

				} else {
					if (self.enableSceneContent) {

						// trigger once
						if (!controls.enabled) {
							controls.enabled=true
							enableSceneTransition()
						}
						ray()
						render()

					} else {

						// trigger once
						if (controls.enabled) {
							controls.enabled=false
							resetHighlights()
							disableSceneTransition()
							resetHighlights()
							render()
						}

					}
				}

				if (self.enableSceneContent) {
					if (stats) {
						stats.end();
					}
				}

				// if (!isTouchDevice()) {
				requestAnimationFrame( animate );
				// }
			}

		}
	}
}
</script>

<style lang="scss" scoped>

#wrapper {
	position: fixed;
	width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
	z-index: 0;
	// cursor: none;

	// * {
	// 	-webkit-touch-callout: none; /* iOS Safari */
	// -webkit-user-select: none; /* Safari */
	//  -khtml-user-select: none; /* Konqueror HTML */
	// 	 -moz-user-select: none; /* Old versions of Firefox */
	// 		-ms-user-select: none; /* Internet Explorer/Edge */
	// 				user-select: none; /* Non-prefixed version, currently
	// 															supported by Chrome, Edge, Opera and Firefox */
	// }

	pointer-events: none;

	&.hovertarget {
		cursor: pointer;
	}
	&.stage_LOADED {
		pointer-events: none;
	}
	&.stage_ENTERED {
		pointer-events: auto;
	}
}
#container {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 0;
	// background: #F7F2EC;
	// background: #F7F2EC;
	/* background: red; */

}
.cursor {
	// display: none;
	font-size: 20px;
	border-radius: 99px;
	width: 1em;
	height: 1em;
	line-height: 0;
	// font-family: sans-serif;
	text-align: center;
	color: white;
	border: 1px solid white;
	// background: blue;
	opacity: 0.5;
	// mix-blend-mode: multiply;
	z-index: 9999;
	pointer-events: none;
	position: fixed;
	margin: -1.5em 0 0 -1.5em;

	border: 1px solid blue;
	background: blue;
	color: white;

	@apply hidden;
	@screen md {
		@apply block;
	}

	span {
		display: block;
		font-size: 12px;
		line-height: 15px;
	}
}
.box {
	position: fixed;
	left: 0;
	bottom: 0;
	z-index: 99;
	font-size: 1.75vw;
	max-width: 28em;
	padding: .5em .5em 1.5em;
	color: white;

	pointer-events: none;
	// color: #00f;

	// right: 0;
	// margin: auto;
	// z-index: 99;
	// max-width: 32em;
	font-size: 1.25rem;
	@screen md {
		font-size: 1.75rem;
	}
	text-shadow: 0px 0px 10px #9f8d8d;
	// text-align: left;
	// background: blue;
	.text-1 {
		font-size: inherit;
		line-height: 1.2;
		// font-size: 125%;
		margin-bottom: 0.5em;
	}
	.object-id {
		display: block;
		// display: none;
		font-size: 250%;
		margin-bottom: 0.15em;
	}
	.text-2 {
		font-size: inherit;
		line-height: 1.2;
		font-style: italic;
	}
}
.fadeinfo-enter {
  opacity: 0;
}

.fadeinfo-enter-active {
  transition: opacity .5s ease;
}

.fadeinfo-leave {}

.fadeinfo-leave-active {
  transition: opacity .2s ease;
  opacity: 0;
}
</style>
